import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import Literal from 'components/literal';
import { Close } from 'components/SvgIcons';
import { CFM_STONE } from 'constants/Colors';
import './styles.scss';

/**
 * General component description.
 */
class InfoModal extends React.Component {
    constructor(props) {
        super(props);

        this.rootSelector = document.getElementById('modal-root');
        this.el = document.createElement('div');

        this.contentRef = React.createRef();
    }

    componentDidMount() {
        this.rootSelector.appendChild(this.el);
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        this.rootSelector.removeChild(this.el);
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Alert if clicked on outside of element
     */
    handleClickOutside = (event) => {
        const { isOpen, closeModal = () => null } = this.props;
        if (isOpen && !this.contentRef.current.contains(event.target)) {
            closeModal(event);
        }
    };

    renderChildren() {
        const {
            className,
            closeModal,
            isMultilang = true,
            isOpen,
            children,
            title = '',
        } = this.props;

        const classNames = ['info-modal'];
        if (className) {
            classNames.push(className);
        }
        if (isOpen) {
            classNames.push('show');
        }

        return (
            <Fragment>
                {isOpen && <div className="modal-overlay over-crud-overlay" />}
                <div className={classNames.join(' ')} ref={this.contentRef}>
                    <div className="info-modal-inside">
                        <div className="info-modal-header">
                            <span className="info-modal-header__text">
                                {isMultilang ? <Literal literal={title} /> : title}
                            </span>
                            <div
                                role="button"
                                tabIndex="-1"
                                className="info-modal-header__close-btn"
                                onClick={closeModal}
                            >
                                <Close color={CFM_STONE} />
                            </div>
                        </div>
                        <div className="info-modal-content">{children}</div>
                    </div>
                </div>
            </Fragment>
        );
    }

    render() {
        return ReactDOM.createPortal(this.renderChildren(), this.el);
    }
}

InfoModal.propTypes = {
    /** Description of prop "children". */
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    /** Indicate if modal is opened */
    isOpen: PropTypes.bool,
    /** Function to call when close modal */
    closeModal: PropTypes.func,
    title: PropTypes.string,
    isMultilang: PropTypes.bool,
    className: PropTypes.string,
};

export default InfoModal;
